
let isPhoneNO = (value) => {
  let patrn = /^1\d{10}$/
  // 香港手机号
  // let patrn1 = /^(852-)\d{8}$/
  // // "[1]"代表下一位为数字可以是几，"[0-9]"代表可以为0-9中的一个，"[5,7,9]"表示可以是5,7,9中的任意一位,
  // // [^4]表示除4以外的任何一个,\d{8}"代表后面是可以是0～9的数字，有8位。
  if (value === '' || value === null) {
    return false
  } else if (!patrn.exec(value)) {
    return false
  }
  return true
}
// 校验座机/手机/香港号码--子账号座机字段
let isSubaccountPhone = (value) => {
  let patrn = /^0(\d{2,3})-?\d{7,8}(-\d{1,5}){0,3}$|^1\d{10}$|^852-?[2689]\d{7}$|^852-?3[014-9]\d{6}$|^852-?3[23]\d{7}$|^852-?5[0-578]\d{6}$|^852-?5[69]\d{7}$|^853-?[1-9]\d{7}$/
  if (value && !patrn.exec(value)) {
    return false
  }
  return true
}
// 固定电话
let isTel = (value) => {
  let patrn = /^(0\d{2,3}-?\d{7,8})|(\d{7,8})$/
  if (value === '' || value === null) {
    return false
  } else if (!patrn.exec(value)) {
    return false
  }
  return true
}
// 邮箱验证
let isEmail = (value) => {
  let patrn = /^([0-9a-zA-Z])+(\.?[0-9a-zA-Z\-_\+\=~]+)*@([0-9a-zA-Z]){1,63}([\-][0-9a-zA-Z]{1,61}){0,31}([\.][0-9a-zA-Z]{1,63}([\-][0-9a-zA-Z]{1,61}){0,31}){0,7}\.[a-zA-Z]{1,63}$/
  if (value === '' || value === null) {
    return false
  } else if (!patrn.exec(value)) {
    return false
  }
  return true
}
export default {
  isPhoneNO,
  isSubaccountPhone,
  isTel,
  isEmail,
}



// WEBPACK FOOTER //
// ./src/gtn/views/frontViews/components/validator.js